import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { faCalendar, faMoon, faPlane, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LdsDealDetails } from '../../ts/interfaces/OphirResponse';
import { useTranslation } from 'react-i18next';
import { SelectCustom } from '@bepro-travel/fe.ui';
import { getGuidesListPath } from '../guidesHelpers';

interface OphirSummaryCardProps {
  details: LdsDealDetails;
}

const OphirSummaryCard: FC<OphirSummaryCardProps> = ({ details }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  const [dates, setDates] = useState<any[]>([]);
  const [selected, setSelected] = useState<string>('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dealId = urlParams.get('dealId');
    const packageId = urlParams.get('packageId');
    const checkIn = urlParams.get('checkIn');

    if (dealId && packageId) {
      const options = sessionStorage.getItem('options_' + dealId + packageId);
      if (options) {
        try {
          const optionsObj = JSON.parse(options);
          const storedDates = optionsObj.dates ?? [];
          setDates(storedDates);

          const defaultSelected =
            checkIn && storedDates.some((d: any) => d.value === checkIn)
              ? checkIn
              : storedDates[0]?.value ?? '';

          if (defaultSelected) {
            setSelected(defaultSelected);
          }
        } catch {
          // ignore parse errors
        }
      }
    }


  }, []);

  const onChangeDate = (value: string) => {
    setSelected(value);

    const selectedDate = dates.find((d: any) => d.value === value);
    const routingValues = selectedDate?.data?.routingValues;

    if (routingValues) {
      const search = new URLSearchParams({ ...routingValues, isSale: true } as any).toString();
      window.location.href = '/tourru/details?' + search;
    }
  };

  return (
    <div className="default-shadow oph-details-sidebar">
      <div className="title text-md">
        <span className="name" dangerouslySetInnerHTML={{ __html: details.hotel.name }}></span>
      </div>
      <div className="mb-10 display-flex">
        <FontAwesomeIcon icon={faCalendar as any} />
        {t('tour.entrance')}: {details.hotel.checkIn}
      </div>
      <div className="mb-10 display-flex">
        <FontAwesomeIcon icon={faCalendar as any} />
        {t('tour.exit')}: {details.hotel.checkOut}
      </div>
      <div className="mb-10 display-flex">
        <FontAwesomeIcon icon={faPlane as any} />
        {t('flight.airport')}: {details.flight.arrivalAirport.name},{' '}
        {details.flight.arrivalAirport.code}
      </div>
      <div className="mb-10 display-flex">
        <FontAwesomeIcon icon={faMoon as any} />
        {t('tour.nights')}: {details.hotel.nightsCount}
      </div>
      {details.suppliments.guideName && (
        <div className="mb-10 display-flex">
          <FontAwesomeIcon icon={faUser as any} />
          {t('tour.guid')}:{' '}
          <Link className="oph-guide-link" to={getGuidesListPath(details.suppliments.guideName)}>
            {details.suppliments.guideName}
          </Link>
        </div>
      )}

      {dates.length > 1 && (
        <div className="mb-10">
          <SelectCustom
            options={dates}
            value={selected}
            onChange={onChangeDate}
            appendToBody
            menuPortralClassName="select-custom__menu-peleg"
            isDropdown={true}
          />
        </div>
      )}
    </div>
  );
};

export default OphirSummaryCard;
